<template>
  <div class="c-search o-wrap--padding-side-default">
    <div class="c-search__grid o-grid o-grid--gutter-small">
      <div class="o-grid__group">
        <div
          v-for="(field, index) in fields"
          :key="index"
          class="o-grid__item o-grid__item--4"
        >
          <label for="search-aed">{{
            searchTranslations[field].name || ""
          }}</label>
          <v-select
            label="name"
            :placeholder="searchTranslations[field].placeholder || ''"
            v-model="parameters[field]"
            :taggable="true"
            :filterable="false"
            :multiple="true"
            :select-on-tab="true"
            @input="searchChange"
            return-object
            :options="field === 'address' ? suggestions : []"
            :reduce="field === 'address' ? option => option.name : undefined"
            v-on="field === 'address' ? { search } : {}"
            :disabled="loading"
          >
            <template slot="option" slot-scope="option">
              <span class="vs__dropdown-option__name">
                {{ option.name }}
              </span>
              <span class="vs__dropdown-option__type">
                {{ searchTranslations.autoSuggestions[option.type] }}
              </span>
            </template>
          </v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { debounce } from "lodash";
export default {
  name: "c-search",
  computed: {
    ...mapState("aeds", ["parameters", "suggestions", "loading"]),
    ...mapState("translations", {
      searchTranslations: "search"
    })
  },
  data() {
    return {
      fields: ["aed", "address", "fadder"],
      disableNoResultsLabel: true
    };
  },
  methods: {
    ...mapActions("aeds", ["getSuggestions", "getAll", "setToUsersAEDs"]),
    ...mapMutations("aeds", ["clearSuggestions"]),
    search: debounce(
      function(value) {
        if (value.length < 2) {
          this.clearSuggestions();
          return;
        }

        this.getSuggestions({ searchTerm: value });
      },
      350,
      true
    ),
    searchChange() {
      this.parameters.pageNo = 1;
      const payload = {
        api: this.$api,
        parameters: this.parameters
      };
      this.getAll(payload);
    }
  },
  created() {
    const fadderId = this.$route.query.fadderId;
    if (fadderId) {
      this.setToUsersAEDs(fadderId);
      this.parameters.pageNo = 1;
      const payload = {
        api: this.$api,
        parameters: this.parameters
      };
      this.getAll(payload);
    }
  }
};
</script>
<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-search {
  padding: toRem(35px 30px 45px);
  background: $s-cp-neutral-white;
  border-top: 1px solid $s-cp-neutral-600;
  border-bottom: 1px solid $s-cp-neutral-600;
  &__grid {
    max-width: toRem(1400px);
  }

  .v-select {
    .vs {
      &__dropdown-toggle {
        padding: 2px;
        border: 1px solid $s-cp-neutral-400;
        @include setStyles("15", $s-typography-sizes);
        width: 100%;
        border-radius: toRem(3px);
        background-color: $s-cp-neutral-white;
      }
      &__dropdown-option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: toRem(5px 15px);
        &--highlight {
          background: $s-cp-sup-blue;
          .vs__dropdown-option__type {
            color: $s-cp-neutral-800;
          }
        }
        &__type {
          @include setStyles("12", $s-typography-sizes);
          color: $s-cp-neutral-400;
        }
        &__name {
          @include setStyles("14", $s-typography-sizes);
          padding-right: toRem(5px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &__dropdown-menu {
        padding: 0;
      }
      &__no-options {
        display: none;
      }
      &__search {
        margin: 4px 2px;
        padding: 0 5px;
        @include setStyles("15", $s-typography-sizes);
        border: 1px solid transparent;
        &::-webkit-search-cancel-button {
          @include sprite("cross");
          -webkit-appearance: none;
          height: 15px;
          width: 15px;
          position: relative;
          cursor: pointer;
        }
        &::placeholder {
          color: $s-cp-neutral-400;
        }
      }

      &__actions {
        display: none;
      }
      &__selected-options {
        align-items: center;
        padding: 0;
        max-width: 100%;
      }
      &__selected {
        margin: 2px;
        padding: 2px 20px 2px 5px;
        border: 1px solid #dcd9d9;
        border-radius: 3px;
        background-color: $s-cp-neutral-800;
        color: $s-cp-main;
        @include setStyles("15", $s-typography-sizes);
        position: relative;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &__deselect {
        position: absolute;
        right: 0;
        margin: 0;
        background-color: $s-cp-neutral-800;
        width: 20px;
        height: 100%;
        svg {
          margin: 0 5px;
          stroke-width: 2px;
          stroke: $s-cp-neutral-800;
          fill: $s-cp-main;
        }
      }
    }
  }
  label {
    @include setStyles("14", $s-typography-sizes);
    margin-bottom: toRem(8px);
    display: block;
  }
}
</style>
